var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "vuestic-chat" }, [
    _c(
      "div",
      {
        directives: [
          {
            name: "sticky-scroll",
            rawName: "v-sticky-scroll",
            value: { animate: true, duration: 500 },
            expression: "{animate: true, duration: 500}",
          },
        ],
        staticClass: "chat-body",
        style: { height: _vm.height },
      },
      _vm._l(_vm.value, function (message, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "chat-message",
            class: { yours: message.yours, alien: !message.yours },
          },
          [_vm._v("\n      " + _vm._s(message.text) + "\n    ")]
        )
      }),
      0
    ),
    _c("div", { staticClass: "chat-controls" }, [
      _c("fieldset", [
        _c("div", { staticClass: "form-group form-group-w-btn" }, [
          _c("div", { staticClass: "input-group" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.inputMessage,
                  expression: "inputMessage",
                },
              ],
              attrs: { required: "", title: "" },
              domProps: { value: _vm.inputMessage },
              on: {
                keypress: function ($event) {
                  return _vm.keyHandler($event)
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.inputMessage = $event.target.value
                },
              },
            }),
            _c("label", { staticClass: "control-label" }, [
              _vm._v("Your message"),
            ]),
            _c("i", { staticClass: "bar" }),
          ]),
          _c(
            "div",
            {
              staticClass: "btn btn-sm btn-primary",
              on: {
                click: function ($event) {
                  return _vm.sendMessage()
                },
              },
            },
            [_vm._v("Send")]
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }